import { sha256 } from '@noble/hashes/sha2';
import { bytesToHex, utf8ToBytes } from '@noble/hashes/utils';
import { z } from 'zod';
import { isAdjustmentLineType } from './adjustment-line-types.js';
/** A lines fingerprint as the API and web send it: lowercase sha256 hex; malformed is bad input, not a stale order. */
export const salesOrderLinesFingerprintSchema = z
    .string()
    .regex(/^[0-9a-f]{64}$/, 'The lines fingerprint is not valid. Reload the order and try again.');
const numberText = (value) => (value === null ? null : String(value));
/** ML-BR-7: identifies the product lines a rep started editing from; sync and browser-safe, so the web and the API hash the same rows. */
export function salesOrderLinesFingerprint(lines) {
    const rows = lines
        .filter((line) => !isAdjustmentLineType(line.typeId))
        .map((line) => ({ ...line, id: line.id.toLowerCase() }))
        // Lowercased first, then code-unit order (not localeCompare), so the hash can't vary with id case or locale.
        .sort((left, right) => (left.id < right.id ? -1 : left.id > right.id ? 1 : 0))
        .map((line) => [
        line.id,
        line.typeId,
        numberText(line.qtyOrdered),
        line.uomId?.toLowerCase() ?? null,
        numberText(line.unitPrice),
        line.name,
        line.note,
    ]);
    return bytesToHex(sha256(utf8ToBytes(JSON.stringify(rows))));
}
//# sourceMappingURL=sales-order-lines-fingerprint.js.map